import type { Achievement } from "../achievement.types";

export const neverLookedBackAchievement: Achievement = {
  id: "neverLookedBack",
  name: "Never Looked Back",
  icon: "ray-start-end",
  description: "Won without backtracking once.",
  isProgressive: true,
  // Rule unchanged from v1's I'm the Juggernaut! (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) {
      return false;
    }
    // Achieved if no backtrack events are present or the array is empty
    return (
      !gameReport.backtrackEvents || gameReport.backtrackEvents.length === 0
    );
  },
};
